import { useCallback, useEffect } from "react";
import { useService } from "../../../../hooks";

export const useTrashConfirmModal = ({
  trashCancelAction,
  showTrashConfirm,
}) => {
  const { openModal, closeModal } = useService("Misc");

  useEffect(() => {
    if (showTrashConfirm) {
      openModal("trash-modal");
    } else {
      closeModal("trash-modal");
    }
  }, [showTrashConfirm, openModal, closeModal]);

  const trashCancel = useCallback(() => {
    if (trashCancelAction) {
      trashCancelAction();
    } else {
      closeModal("trash-modal");
    }
  }, [trashCancelAction, closeModal]);

  return {
    trashCancel,
  };
};
